const AGENDA_UI_ANALYTICS_EVENT = {
  WORKOUT_COPIED: 'Agenda Workout Copied',
  DATE_UPDATED: 'Agenda Date Updated',
  DATES_PREMIUM: 'Agenda Dates Premium',
  ADD_WORKOUT_PREMIUM: 'Agenda Add Workout Premium'
}

const AGENDA_UI_ACTION = {
  UPDATE_DATE: 'AGENDA_UI_UPDATE_DATE'
}

const AGENDA_UI_DOMAIN = 'activityUi'

const AGENDA_UI_KEY = {
  DATE: 'date'
}

const AGENDA_UI_PATH = {
  DATE: `${AGENDA_UI_DOMAIN}.${AGENDA_UI_KEY.DATE}`
}

const AGENDA_UI_STATE = {
  [AGENDA_UI_KEY.DATE]: null
}

export {
  AGENDA_UI_ACTION,
  AGENDA_UI_ANALYTICS_EVENT,
  AGENDA_UI_PATH,
  AGENDA_UI_DOMAIN,
  AGENDA_UI_STATE
}
